// src/app/guards/oauth.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of, switchMap } from 'rxjs';
import { AuthService } from './core/auth/auth.service';
import { OrgService } from './modules/org-sys-area/services/org.service';

export const oauthGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const orgService = inject(OrgService);

    return authService.check().pipe(
        switchMap(authenticated => {
            if (!authenticated) {
                localStorage.setItem('redirectUrl', state.url);
                router.navigate(['/sign-in']);
                return of(true);
            }

            return authService.getUser().pipe(
                catchError(() => {
                    localStorage.setItem('redirectUrl', state.url);
                    router.navigate(['/sign-in']);
                    return of(true);
                }),
                switchMap(() => {
                    const redirectUrl = localStorage.getItem('redirectUrl');
                    if (redirectUrl) {
                        localStorage.removeItem('redirectUrl');

                        router.navigateByUrl(redirectUrl);
                        return of(true);
                    }

                    let orgId = localStorage.getItem('organisation');
                    const isRootUrl = state.url === '/' || state.url === '';

                    if (!orgId) {
                        return orgService.getSimpleOrganisationsForUsers().pipe(
                            map(() => {
                                orgId = localStorage.getItem('organisation');
                                // fallback if orgId missing — still redirect to /bp
                                router.navigate([`/${orgId}/bp`]);
                                return false;
                            })
                        );
                    }

                    if (isRootUrl) {
                        router.navigate([`/${orgId}/bp`]);
                        return of(false);
                    }

                    return of(true);
                })
            );
        })
    );
};
